import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';
import CubeMark from '../components/CubeMark.jsx';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const user = await login(email, password);
      navigate(user.role === 'coach' ? '/coach' : '/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-ink-950 relative overflow-hidden">
      <div className="absolute inset-0 hairlines opacity-60" />
      <div className="w-full max-w-md relative">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-5">
            <CubeMark size={52} />
          </div>
          <h1 className="text-2xl font-bold text-slate-100">魔方训练营</h1>
          <p className="text-sm text-slate-500 mt-1.5">学生自己打卡，教练看得见</p>
        </div>

        <div className="card p-6 shadow-2xl">
          <h2 className="text-lg font-semibold text-slate-100 mb-5">登录</h2>
          {error && (
            <div className="mb-4 text-sm bg-danger/10 text-danger border border-danger/20 rounded-xl px-3.5 py-2.5">
              {error}
            </div>
          )}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label">邮箱</label>
              <input
                className="input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoComplete="email"
              />
            </div>
            <div>
              <label className="label">密码</label>
              <input
                className="input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="至少 6 位"
                required
                autoComplete="current-password"
              />
            </div>
            <button className="btn-primary w-full" disabled={busy}>
              {busy ? '登录中…' : '登录'}
            </button>
          </form>

          <div className="mt-5 pt-5 border-t border-slate-700/50 text-sm text-slate-400 flex justify-between">
            <span>
              还没有账号？
              <Link to="/register" className="text-accent hover:underline ml-1">注册</Link>
            </span>
          </div>
        </div>

        <div className="mt-4 card p-4 text-xs text-slate-500">
          <p className="mb-1"><span className="text-slate-300">演示教练</span> coach@cube.cn / coach123</p>
          <p><span className="text-slate-300">演示学生</span> student@demo.cn / student123</p>
        </div>
      </div>
    </div>
  );
}
